/**
 * API 运行时守卫
 * 开发环境下检测 API 模块中的字符串常量，防止静默失效
 */

/**
 * 递归检查 API 模块中的字符串常量
 * @param {Object} module - 要检查的 API 模块
 * @param {string} path - 当前路径（用于输出错误信息）
 * @param {WeakSet} visited - 已访问的对象集合（防止循环引用）
 */
export function validateApiModule(module, path = 'api', visited = new WeakSet()) {
  // 仅在开发环境启用
  if (process.env.NODE_ENV !== 'development') return;

  // 防止循环引用导致的无限递归
  if (module === null || typeof module !== 'object') return;

  // 跳过已访问的对象
  if (visited.has(module)) return;
  visited.add(module);

  Object.entries(module).forEach(([key, value]) => {
    const currentPath = `${path}.${key}`;

    if (typeof value === 'string') {
      // 跳过以 Url 结尾的属性（供 el-upload 等组件使用的 URL 字符串）
      if (key.endsWith('Url')) return;
      // 跳过以 URL 结尾的属性
      if (key.endsWith('URL')) return;
      const strPreview = value.length > 50 ? value.substring(0, 50) + '...' : value;
      console.error(
        `[API ERROR] ${currentPath} 是字符串常量（"${strPreview}"），` +
        `应改为函数。调用方式需从 this.axios.post(this.api.xxx, data) ` +
        `改为 this.api.xxx(data)`
      );
    } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      // 递归检查子模块
      validateApiModule(value, currentPath, visited);
    }
  });
}

/**
 * 检查单个值是否为字符串常量
 * 用于构建时检查脚本
 * @param {*} value
 * @returns {boolean}
 */
export function isStringConstant(value) {
  return typeof value === 'string' && value.length > 0;
}

export default {
  validateApiModule,
  isStringConstant
};
